import React from 'react';

/**
 * Numbered "How it works" step cards.
 *
 * Props:
 *   steps   - array of { no, icon, title, desc }
 *   variant - 'dark' (default, white text) | 'light' (dark text on white cards)
 */
const StepCards = ({ steps = [], variant = 'dark' }) => {
  if (steps.length === 0) return null;

  return (
    <div className="rr-steps-grid">
      {steps.map((step) => (
        <div
          key={step.no}
          className={`rr-step-card${variant === 'light' ? ' rr-step-card--light' : ''}`}
        >
          <div className="rr-step-card__no">{step.no}</div>
          <div className="rr-step-card__icon">{step.icon}</div>
          <div className="rr-step-card__title">{step.title}</div>
          <div className="rr-step-card__desc">{step.desc}</div>
        </div>
      ))}
    </div>
  );
};

export default StepCards;
